import { render, staticRenderFns } from "./TotalizadoresCaixaPostal.vue?vue&type=template&id=87be5f34&"
import script from "./TotalizadoresCaixaPostal.vue?vue&type=script&lang=js&"
export * from "./TotalizadoresCaixaPostal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports